import "scss/style.scss";
import { WebRoutes } from "./router";

function App() {
  return <WebRoutes />;
}

export default App;
